function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState } from 'react';

/**
 * @param onActive 接收一个promise函数
 * @param onActiveParams promise函数的入参
 * @param onActiveSuccess promise函数执行成功之后回调
 * @param onActiveFail promise函数执行失败之后回调
 * @param styleClass div样式
 */

var Index = function Index(props) {
  var onActive = props.onActive,
    onActiveParams = props.onActiveParams,
    onActiveSuccess = props.onActiveSuccess,
    onActiveFail = props.onActiveFail,
    styleClass = props.styleClass,
    children = props.children;
  onActiveSuccess = onActiveSuccess || function () {};
  onActiveFail = onActiveFail || function () {};
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLoading = _useState2[0],
    setShowLoading = _useState2[1];
  var doActive = function doActive(e) {
    e.stopPropagation();
    if (!showLoading) {
      setShowLoading(true);
      if (onActiveParams !== undefined) {
        onActive(onActiveParams).then(function (res) {
          onActiveSuccess(res);
          setShowLoading(false);
        }).catch(function (err) {
          onActiveFail(err);
          setShowLoading(false);
        });
      } else {
        onActive().then(function (res) {
          onActiveSuccess(res);
          setShowLoading(false);
        }).catch(function (err) {
          onActiveFail(err);
          setShowLoading(false);
        });
      }
    }
  };
  var DebounceBtn = useMemo(function () {
    var FinialChildren = React.Children.map(children, function (childItem) {
      return /*#__PURE__*/React.cloneElement(childItem, {
        disabled: showLoading
      });
    });
    return FinialChildren;
  }, [showLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: [styleClass ? styleClass : ''].join(' '),
    onClick: doActive
  }, DebounceBtn);
};
export default Index;